import React from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import * as actions from "../AuthActions";

class Logout extends React.Component {

    componentWillMount(){
        this.logout();
    }

    logout = () => {
        const history = this.props.router || this.props.history;
        this.props.dispatch(actions.logout(() => history.push('/login')));
    }

    render() {
        return null
    }
}

function mapStateToProps(state) {
    return {auth: state.auth};
}

export default connect(mapStateToProps)(withRouter(Logout));



// WEBPACK FOOTER //
// ./src/auth/components/Logout.js